import { Box } from '@mui/material';
import LinearProgress from 'src/components/LinearProgress';

function SuspenseLoader() {

  return (
    <Box
    >
      <LinearProgress sx={{ p: 0 }} />
    </Box>
  );
}

export default SuspenseLoader;
